import { render, staticRenderFns } from "./invoice-expenses.vue?vue&type=template&id=cdc9f81a"
import script from "./invoice-expenses.vue?vue&type=script&lang=js"
export * from "./invoice-expenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports